import React from "react";
import MainWrapper from "../../Layouts/MainWrapper";
import AdminRoutes from "./AdminRoutes";
import AdminView from './AdminView';
import { DataContext } from "../../../state/DataContext/DataContext";
import { useParams } from "react-router-dom";

export default function AdminMain() {
    let { tenantID } = useParams<any>();
    const { actions } = React.useContext(DataContext);

    React.useEffect(() => {
        actions.setTenantID(tenantID);
    }, [JSON.stringify(tenantID)])

    // pass switch component and sidebar into DashboardWrapper, DashboardWrapper wraps the navigation for us so we can keep it dry
    return <MainWrapper
        sidebarcomponent={AdminRoutes}
        switchcomponent={AdminView}
    />
}
